jQuery(document).ready(function(){
    $(document).on('change', '#choose_service', function(event) {
        event.preventDefault();

        $(this).closest('list_detail ').addClass('active');

        var variantId = $(this).data('vid');

       // alert("Variant ID: " + variantId);

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id: variantId,
                quantity: 1
            },
            success: function(response){
                window.location.reload();
            },
            error: function(xhr, status, error) {
                console.error(xhr.responseText);
                alert("Error: " + xhr.responseText);
            }
        });
    });

    $(document).on('click', '#remove_cart', function(event) {
      event.preventDefault();
    
      var variantId = $(this).data('vid');
     // alert('Variant ID: ' + variantId);
    
      $.getJSON('/cart.js', function(cart) {
        var lineKey = null;
    
        cart.items.forEach((item) => {
          if (item.variant_id === variantId) {
            lineKey = item.key;
          }
        });
    
        if (lineKey) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              id: lineKey,       
              quantity: 0  
            },
            success: function(response) {
             // alert('Item removed!');
              location.reload();
            },
            error: function(xhr) {
              console.error(xhr.responseText);
              alert("Error: " + xhr.responseText);
            }
          });
        } else {
          alert('Variant not found in cart.');
        }
      });
    });


});

